import React, { useEffect, useRef, useState } from 'react';
import './Stats.css';

function StatItem({ target, unit, label }) {
  const [count, setCount] = useState(0);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        let start = 0;
        const duration = 1500;
        const step = (timestamp) => {
          if (!start) start = timestamp;
          const progress = Math.min((timestamp - start) / duration, 1);
          setCount(Math.floor(progress * target));
          if (progress < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
        observer.disconnect();
      }
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <div className="stats__item" ref={ref}>
      <div>
        <span className="stat-num">{count}</span>
        <span className="stat-unit">{unit}</span>
      </div>
      <p>{label}</p>
    </div>
  );
}

export default function Stats() {
  return (
    <section className="stats">
      <StatItem target={12} unit="x" label="Average ROI" />
      <StatItem target={98} unit="%" label="Client Retention" />
      <StatItem target={3} unit="+" label="Years of Experience" />
      <StatItem target={50} unit="+" label="Brands Scaled" />
    </section>
  );
}